import { useEffect } from "react";

const DEFAULTS = {
  title: "Счетоводна къща RightAccount | Счетоводни услуги, ТРЗ и регистриране на фирми — Пловдив",
  description:
    "Счетоводна къща RightAccount — Пловдив. Счетоводни услуги за фирми: счетоводство и абонаментно обслужване, регистриране на фирми, труд и работна заплата (ТРЗ), данъчни консултации и трудови консултации. Кантора с 15+ години опит.",
  canonical: "https://rightaccountplovdiv.com/",
};

const setMeta = (selector, attr, value) => {
  const el = document.head.querySelector(selector);
  if (el) el.setAttribute(attr, value);
};

export const useSeo = ({ title, description, canonical, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    setMeta('meta[name="description"]', "content", description);
    setMeta('link[rel="canonical"]', "href", canonical);
    setMeta('meta[property="og:title"]', "content", title);
    setMeta('meta[property="og:description"]', "content", description);
    setMeta('meta[property="og:url"]', "content", canonical);
    setMeta('meta[name="twitter:title"]', "content", title);
    setMeta('meta[name="twitter:description"]', "content", description);

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.dataset.page = "true";
    script.text = JSON.stringify(jsonLd);
    document.head.appendChild(script);

    return () => {
      document.title = DEFAULTS.title;
      setMeta('meta[name="description"]', "content", DEFAULTS.description);
      setMeta('link[rel="canonical"]', "href", DEFAULTS.canonical);
      setMeta('meta[property="og:url"]', "content", DEFAULTS.canonical);
      script.remove();
    };
  }, [title, description, canonical, jsonLd]);
};
